import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    template: `
        <div mat-dialog-title>Preview</div>
        <div mat-dialog-content style="width: 650px; overflow: hidden;">
            <briefing-preview [briefingId]="data.briefingId" [visible]="true"></briefing-preview>
        </div>
        <div mat-dialog-actions>
            <button mat-button mat-dialog-close>Done</button>
        </div>
    `
})
export class BriefingPreviewDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: { briefingId: string}) {}
}